import ceoimg from "./ceo.jpg";
import agentfemaleimg from "./julie-nextkey.jpg";
import agentmaleimg from "./daniel-nextkey.jpg";

export const ceo = ceoimg;
export const agentfemale = agentfemaleimg;
export const agentmale = agentmaleimg;
